/* tslint:disable */
/* eslint-disable */
/**
 * Performo API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.29.3
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { ColumnDisplayOptionFromJSON, ColumnDisplayOptionToJSON, } from './';
export function PerformoSettingsFromJSON(json) {
    return PerformoSettingsFromJSONTyped(json, false);
}
export function PerformoSettingsFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'fmRecordId': !exists(json, 'fmRecordId') ? undefined : json['fmRecordId'],
        'fmModId': !exists(json, 'fmModId') ? undefined : json['fmModId'],
        'defaultRequesterPropertyId': !exists(json, 'defaultRequesterPropertyId') ? undefined : json['defaultRequesterPropertyId'],
        'systemLogo': !exists(json, 'systemLogo') ? undefined : json['systemLogo'],
        'systemLogoText': !exists(json, 'systemLogoText') ? undefined : json['systemLogoText'],
        'homeScreenAnnouncement1': !exists(json, 'homeScreenAnnouncement1') ? undefined : json['homeScreenAnnouncement1'],
        'createRequestContactsFlag': !exists(json, 'createRequestContactsFlag') ? undefined : json['createRequestContactsFlag'],
        'autoProvisionExternalUsers': !exists(json, 'autoProvisionExternalUsers') ? undefined : json['autoProvisionExternalUsers'],
        'webAddressExternal': !exists(json, 'webAddressExternal') ? undefined : json['webAddressExternal'],
        'surveyActiveFlag': !exists(json, 'surveyActiveFlag') ? undefined : json['surveyActiveFlag'],
        'nonInvPartSerial': !exists(json, 'nonInvPartSerial') ? undefined : json['nonInvPartSerial'],
        'completeConfirmation': !exists(json, 'completeConfirmation') ? undefined : json['completeConfirmation'],
        'useAllPropertyForRequestTypesVList': !exists(json, 'useAllPropertyForRequestTypesVList') ? undefined : json['useAllPropertyForRequestTypesVList'],
        'useAllPropertyForPriorityVList': !exists(json, 'useAllPropertyForPriorityVList') ? undefined : json['useAllPropertyForPriorityVList'],
        'secondaryAssignee': !exists(json, 'secondaryAssignee') ? undefined : json['secondaryAssignee'],
        'secondaryAssigneeLabel': !exists(json, 'secondaryAssigneeLabel') ? undefined : json['secondaryAssigneeLabel'],
        'requireAssetForCompletion': !exists(json, 'requireAssetForCompletion') ? undefined : json['requireAssetForCompletion'],
        'requireLaborForCompletion': !exists(json, 'requireLaborForCompletion') ? undefined : json['requireLaborForCompletion'],
        'requireNoteForCompletion': !exists(json, 'requireNoteForCompletion') ? undefined : json['requireNoteForCompletion'],
        'requirePublicNoteForDNC': !exists(json, 'requirePublicNoteForDNC') ? undefined : json['requirePublicNoteForDNC'],
        'requirePrivateNoteForDNC': !exists(json, 'requirePrivateNoteForDNC') ? undefined : json['requirePrivateNoteForDNC'],
        'allowEnteringRequestsForOthers': !exists(json, 'allowEnteringRequestsForOthers') ? undefined : json['allowEnteringRequestsForOthers'],
        'requireProfileForRequests': !exists(json, 'requireProfileForRequests') ? undefined : json['requireProfileForRequests'],
        'enableTimecardModule': !exists(json, 'enableTimecardModule') ? undefined : json['enableTimecardModule'],
        'workOrderListColumnOptions': !exists(json, 'workOrderListColumnOptions') ? undefined : (json['workOrderListColumnOptions'] === null ? null : json['workOrderListColumnOptions'].map(ColumnDisplayOptionFromJSON)),
        'assetListColumnOptions': !exists(json, 'assetListColumnOptions') ? undefined : (json['assetListColumnOptions'] === null ? null : json['assetListColumnOptions'].map(ColumnDisplayOptionFromJSON)),
        'requiredProfileAttributes': !exists(json, 'requiredProfileAttributes') ? undefined : json['requiredProfileAttributes'],
        'multiPropLabelSingular': !exists(json, 'multiPropLabelSingular') ? undefined : json['multiPropLabelSingular'],
        'multiPropLabelPlural': !exists(json, 'multiPropLabelPlural') ? undefined : json['multiPropLabelPlural'],
        'multiPropLabelAbbrev': !exists(json, 'multiPropLabelAbbrev') ? undefined : json['multiPropLabelAbbrev'],
        'googleMapsAPIkey': !exists(json, 'googleMapsAPIkey') ? undefined : json['googleMapsAPIkey'],
        'googleMapsKeyMode': !exists(json, 'googleMapsKeyMode') ? undefined : json['googleMapsKeyMode'],
        'googleMapsClientID': !exists(json, 'googleMapsClientID') ? undefined : json['googleMapsClientID'],
        'advancedPartsFunctionalityFlag': !exists(json, 'advancedPartsFunctionalityFlag') ? undefined : json['advancedPartsFunctionalityFlag'],
        'workOrderEntityTransfer': !exists(json, 'workOrderEntityTransfer') ? undefined : json['workOrderEntityTransfer'],
        'openSubStatuses': !exists(json, 'openSubStatuses') ? undefined : json['openSubStatuses'],
        'completeSubStatuses': !exists(json, 'completeSubStatuses') ? undefined : json['completeSubStatuses'],
        'isOrderOpeningHandlerConfigured': !exists(json, 'isOrderOpeningHandlerConfigured') ? undefined : json['isOrderOpeningHandlerConfigured'],
        'isOrderOpenedHandlerConfigured': !exists(json, 'isOrderOpenedHandlerConfigured') ? undefined : json['isOrderOpenedHandlerConfigured'],
        'isOrderHoldingHandlerConfigured': !exists(json, 'isOrderHoldingHandlerConfigured') ? undefined : json['isOrderHoldingHandlerConfigured'],
        'isOrderHeldHandlerConfigured': !exists(json, 'isOrderHeldHandlerConfigured') ? undefined : json['isOrderHeldHandlerConfigured'],
        'isOrderDNCingHandlerConfigured': !exists(json, 'isOrderDNCingHandlerConfigured') ? undefined : json['isOrderDNCingHandlerConfigured'],
        'isOrderDNCedHandlerConfigured': !exists(json, 'isOrderDNCedHandlerConfigured') ? undefined : json['isOrderDNCedHandlerConfigured'],
        'isOrderCompletingHandlerConfigured': !exists(json, 'isOrderCompletingHandlerConfigured') ? undefined : json['isOrderCompletingHandlerConfigured'],
        'isOrderCompletedHandlerConfigured': !exists(json, 'isOrderCompletedHandlerConfigured') ? undefined : json['isOrderCompletedHandlerConfigured'],
    };
}
export function PerformoSettingsToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'fmRecordId': value.fmRecordId,
        'fmModId': value.fmModId,
        'defaultRequesterPropertyId': value.defaultRequesterPropertyId,
        'systemLogo': value.systemLogo,
        'systemLogoText': value.systemLogoText,
        'homeScreenAnnouncement1': value.homeScreenAnnouncement1,
        'createRequestContactsFlag': value.createRequestContactsFlag,
        'autoProvisionExternalUsers': value.autoProvisionExternalUsers,
        'webAddressExternal': value.webAddressExternal,
        'surveyActiveFlag': value.surveyActiveFlag,
        'nonInvPartSerial': value.nonInvPartSerial,
        'completeConfirmation': value.completeConfirmation,
        'useAllPropertyForRequestTypesVList': value.useAllPropertyForRequestTypesVList,
        'useAllPropertyForPriorityVList': value.useAllPropertyForPriorityVList,
        'secondaryAssignee': value.secondaryAssignee,
        'secondaryAssigneeLabel': value.secondaryAssigneeLabel,
        'requireAssetForCompletion': value.requireAssetForCompletion,
        'requireLaborForCompletion': value.requireLaborForCompletion,
        'requireNoteForCompletion': value.requireNoteForCompletion,
        'requirePublicNoteForDNC': value.requirePublicNoteForDNC,
        'requirePrivateNoteForDNC': value.requirePrivateNoteForDNC,
        'allowEnteringRequestsForOthers': value.allowEnteringRequestsForOthers,
        'requireProfileForRequests': value.requireProfileForRequests,
        'enableTimecardModule': value.enableTimecardModule,
        'workOrderListColumnOptions': value.workOrderListColumnOptions === undefined ? undefined : (value.workOrderListColumnOptions === null ? null : value.workOrderListColumnOptions.map(ColumnDisplayOptionToJSON)),
        'assetListColumnOptions': value.assetListColumnOptions === undefined ? undefined : (value.assetListColumnOptions === null ? null : value.assetListColumnOptions.map(ColumnDisplayOptionToJSON)),
        'requiredProfileAttributes': value.requiredProfileAttributes,
        'multiPropLabelSingular': value.multiPropLabelSingular,
        'multiPropLabelPlural': value.multiPropLabelPlural,
        'multiPropLabelAbbrev': value.multiPropLabelAbbrev,
        'googleMapsAPIkey': value.googleMapsAPIkey,
        'googleMapsKeyMode': value.googleMapsKeyMode,
        'googleMapsClientID': value.googleMapsClientID,
        'advancedPartsFunctionalityFlag': value.advancedPartsFunctionalityFlag,
        'workOrderEntityTransfer': value.workOrderEntityTransfer,
        'openSubStatuses': value.openSubStatuses,
        'completeSubStatuses': value.completeSubStatuses,
        'isOrderOpeningHandlerConfigured': value.isOrderOpeningHandlerConfigured,
        'isOrderOpenedHandlerConfigured': value.isOrderOpenedHandlerConfigured,
        'isOrderHoldingHandlerConfigured': value.isOrderHoldingHandlerConfigured,
        'isOrderHeldHandlerConfigured': value.isOrderHeldHandlerConfigured,
        'isOrderDNCingHandlerConfigured': value.isOrderDNCingHandlerConfigured,
        'isOrderDNCedHandlerConfigured': value.isOrderDNCedHandlerConfigured,
        'isOrderCompletingHandlerConfigured': value.isOrderCompletingHandlerConfigured,
        'isOrderCompletedHandlerConfigured': value.isOrderCompletedHandlerConfigured,
    };
}
